import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const noPlanToRenew: RouteConfig<'with-page'> = {
    name: 'No Plan to Renew',
    context: 'member',
    path: '/myaccount/no-plan-to-renew',
    page: lazy(() => import('.')),
    flags: ['member-route','no-menu-item'],
}